import axios from 'axios'
axios.defaults.baseURL = API_URL

import 'braindamage/initializer'
import 'index'
